class IntroPricingModal {
  constructor () {
    this.template = document.getElementById('intro-pricing-modal-template')
    this.boundHandleClick = this.handleClick.bind(this)
    this.init()
  }

  init () {
    document.addEventListener('click', this.boundHandleClick)
  }

  handleClick (event) {
    const trigger = event.target.closest('[data-intro-pricing-trigger]')
    if (!trigger) return

    event.preventDefault()
    this.openModal()
  }

  openModal () {
    if (!this.template) {
      console.warn('Intro pricing modal template not found')
      return
    }

    const modal = document.querySelector('reusable-modal')
    if (!modal) {
      console.warn('Reusable modal not found')
      return
    }

    const modalTitle = modal.querySelector('.reusable-modal__title')
    const modalBody = modal.querySelector('.reusable-modal__body')

    if (modalTitle) {
      modalTitle.innerHTML = ''
    }

    if (modalBody) {
      const content = this.template.content.cloneNode(true)
      modalBody.innerHTML = ''
      modalBody.appendChild(content)
    }

    window.dispatchEvent(new CustomEvent('open:modal', {
      detail: {
        width: 'min(600px, 100svw)',
        padding: 'none',
        modalClassAdd: ['max-h-[90vh]'],
        modalClassRemove: ['max-h-[80vh]'],
        headerClassAdd: ['absolute', 'h-12.5', 'top-0', 'left-0', 'right-0', 'z-20', 'block'],
        headerClassRemove: ['border-b', 'grid', 'mb-4', 'pb-2', 'border-clay'],
        bodyClassAdd: ['relative', 'z-10'],
        closeClassAdd: ['absolute', 'top-2', 'right-2', 'z-20'],
        closeClassRemove: [],
      },
    }))
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    // eslint-disable-next-line no-new
    new IntroPricingModal()
  })
} else {
  // eslint-disable-next-line no-new
  new IntroPricingModal()
}
